import React, { Component } from 'react';
import { List } from 'immutable';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import Loader from 'components/FullScreenLoader';// to show loder on screen whenever there is a api call or operations in component
import { Link } from 'react-router-dom'; //  to change path from inside or to alter react-router-dom path
import { Button } from 'react-toolbox/lib/button';
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import styles from './Billings.scss';// to import local scss fle


class Billings extends Component {
  static propTypes = {
    getPaymentHistory: PropTypes.func,
    profile: PropTypes.shape(),
    transactions: PropTypes.shape(),
    paymentRequested: PropTypes.bool,
  };

  static defaultProps = {
    getPaymentHistory: () => {},
    profile: {},
    transactions: {},
    paymentRequested: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      noContentFound: false,
    };
  }
  componentWillMount() {
    if (this.props.profile.size > 0) {
      const paymentInfo = this.props.profile.get('payment_info');
      if (paymentInfo !== undefined) {
        const customerId = this.props.profile.get('customer_id');
        this.props.getPaymentHistory(customerId);
      } else {
        this.setState({ noContentFound: true });
      }
    }
  }

  render() {
    const renderLoader = renderIf(this.props.paymentRequested);
    let currentPlanId = List();
    if (this.props.transactions.size > 0) {
      currentPlanId = this.props.transactions.get('transactions').last();
    }
    const renderNoContentFound = renderIf(this.state.noContentFound);
    const renderCurrentPlanId = renderIf(currentPlanId.size > 0);
    return (
      <div className={cn('row', styles.container)}>
        {renderLoader(
          <Loader />,
                )}
        {renderNoContentFound(
          <div>
            <span className={styles.dontHaveAnything}>You dont have any payment history. </span>
            <div className={cn('col s12', styles.buttonContainer)}>
              <Link to="/pricing" >
                <Button className={styles.continue} >UPGRADE NOW </Button>
              </Link>
            </div>
          </div>,

                )}

        <div className={cn('col s12', styles.currentPlan)}>
          <span>YOUR CURRENT PLAN</span>
        </div>
        {renderCurrentPlanId(
          <div className={cn('col s12', styles.packageInfo)}>
            {currentPlanId.get('planId')}
          </div>,
          )}
        {this.props.transactions.map(payments => (
                    payments.map(payment =>
                      <div>
                        <div className={cn('col s12', styles.buttonContainer)}>
                          {/* <Link to="/pricing" > */}
                          {/* <button className={styles.continue} >UPGRADE NOW </button> */}
                          {/* </Link> */}
                        </div>
                        <div className={cn('col s12', styles.invoiceHistory)}>
                          <span>INVOICE HISTORY</span>
                        </div>
                        <div className={cn('col s12', styles.invoiceListContainer)}>
                          <div className={cn('col s12', styles.invoiceList)}>
                            <div className={cn('col s6', styles.firstHalf)}>
                              <span className={styles.alignMiddle}>
                                <span className={styles.planIdInList}>
                                  {payment.get('planId') }
                                </span>
                                <br />
                                <span className={styles.paymentMadeOn}>
                          Payment made on {payment.get('transactionDate')}
                                </span>
                              </span>
                            </div>
                            <div className={cn('col s6', styles.secondHalf)}>
                              <span className={styles.alignMiddle}>
                                <span className={styles.transactionId}>
                      Transaction ID <br />
                                  {payment.get('id')}
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>,
                    )))}
      </div>
    );
  }
}

export default Billings;



// WEBPACK FOOTER //
// ./src/components/Billings/Billings.js